import { queryClient } from '../core/queryClient';
import { liveReportsQueryKey } from '../queries/liveReports';
import { reportTemplatesQueryKey } from '../queries/reportTemplates';
import { performanceDashboardsQueryKey } from '../queries/performanceDashboards';
import {
  reportSchedulesQueryKey,
  awaitingReviewReportsQueryKey,
  exportedReportsQueryKey,
  dispatchedReportsQueryKey
} from '../queries/reportSchedules';

export const invalidateLiveReports = (organisationId: string, workspaceId: string, isConsolidation: boolean) => {
  queryClient.invalidateQueries({
    queryKey: liveReportsQueryKey(organisationId, workspaceId, isConsolidation)
  });
};

export const invalidateReportTemplates = (
  organisationId: string,
  workspaceId: string,
  isConsolidation: boolean | undefined
) => {
  queryClient.invalidateQueries({
    queryKey: reportTemplatesQueryKey(organisationId, workspaceId, !!isConsolidation)
  });
};

export const invalidatePerformanceDashboards = (organisationId: string, workspaceId: string) => {
  queryClient.invalidateQueries({
    queryKey: performanceDashboardsQueryKey(organisationId, workspaceId)
  });
};

export const invalidateReportSchedules = (
  organisationId: string,
  workspaceId: string,
  isConsolidation: boolean | undefined
) => {
  queryClient.invalidateQueries({
    queryKey: reportSchedulesQueryKey(organisationId, workspaceId, !!isConsolidation)
  });
};

export const invalidateAwaitingReviewReports = (
  organisationId: string,
  workspaceId: string,
  isConsolidation: boolean | undefined
) => {
  queryClient.invalidateQueries({
    queryKey: awaitingReviewReportsQueryKey(organisationId, workspaceId, !!isConsolidation)
  });
};

export const invalidateExportedReports = (
  organisationId: string,
  workspaceId: string,
  isConsolidation: boolean | undefined
) => {
  queryClient.invalidateQueries({
    queryKey: exportedReportsQueryKey(organisationId, workspaceId, !!isConsolidation)
  });
};

export const invalidateDispatchedReports = (
  organisationId: string,
  workspaceId: string,
  isConsolidation: boolean | undefined
) => {
  queryClient.invalidateQueries({
    queryKey: dispatchedReportsQueryKey(organisationId, workspaceId, !!isConsolidation)
  });
};
